module.exports = __webpack_public_path__ + "static/media/times.07277854.svg";